export default "__VITE_ASSET__9ac1e411__"